<div class="container-tig-item">
    <div class="help-c-title">
        <h4>蒙古文无衬线报体和蒙古文白体比较</h4>
    </div>
    <div>
        <p>目前蒙古文字体中不管是印刷还是网络媒体最广泛用的是蒙古文白体，那么我们下面与蒙古文白体 比较说明蒙古文无衬线报体有哪些特点和优点。</p>
        <br>
        <p>首先比较两种字体占用面积的宽度：(长度一样的同一个字，左白体、右无衬线报体）</p>
    </div>
    <div class="Vsbt-img-cont">
        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/1.gif" alt="斡仑字体 - 图片">
            <div>图1</div>
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/2.gif" alt="斡仑字体 - 图片">
            <div>图2</div>
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/3.gif" alt="斡仑字体 - 图片">
            <div>图3</div>
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/4.gif" alt="斡仑字体 - 图片">
            <div>图4</div>
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/5.gif" alt="斡仑字体 - 图片">
            <div>图5</div>
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/6.gif" alt="斡仑字体 - 图片">
            <div>图6</div>
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/7.gif" alt="斡仑字体 - 图片">
            <div>图7</div>
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/8.gif" alt="斡仑字体 - 图片">
            <div>图8</div>
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/9.gif" alt="斡仑字体 - 图片">
            <div>图9</div>
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/10.gif" alt="斡仑字体 - 图片">
            <div>图10</div>
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/11.gif" alt="斡仑字体 - 图片">
            <div>图11</div>
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/12.gif" alt="斡仑字体 - 图片">
            <div>图12</div>
        </div>

    </div>
    <div>
        <p>以上12个字用两种字体进行比较时同长度情况下，10个字的宽度用白体写时比无衬线报体写的大， 一个字的同样大（图10），还有一个字用无衬线报体写时比白体写的大（图11）。这就说明除了一 些特殊例子之外同一个字在同长度情况下无衬线报体占用面积比白体小。那么哪些是特殊例子呢， 比如：一个字体以<span class="mgl"> ᠱᠠ‍ </span> 开头字中带<span class="mgl"> ‍ᠭᠠ‍ </span>、字中带<span class="mgl"> ᠳ᠋ᠠ‍ </span>而且长度短的一些字、
            <span
                class="mgl">ᠱᠠ‍ </span> 或<span class="mgl"> ᠰᠠ‍ </span> 开头<span class="mgl"> ‍ᠨ</span> 结尾长度 短的一些字（图13、图14、图15）。</p>
    </div>
    <div class="Vsbt-img-cont">
        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/13.gif" alt="斡仑字体 - 图片">
            <div>图13</div>
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/14.gif" alt="斡仑字体 - 图片">
            <div>图14</div>
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/15.gif" alt="斡仑字体 - 图片">
            <div>图15</div>
        </div>
    </div>
    <div>
        <p>同一段内容比较(左白体、右无衬线报体）</p>
    </div>
    <div class="Vsbt-img-cont">
        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/16.gif" alt="斡仑字体 - 图片">
            <div>图16</div>
        </div>
    </div>

    <p>两种字体以同一段内容（同长度字体，同行距）比较后发现（图16）:无衬线报体字间距比白体字间 距小，所以占用的面积小。这说明同一段内容，无衬线报体在更小的面积里很清楚的传达文字信息， 视觉效果更好。</p>
    <br>
    <p>总结：通过上面两个例子我们得出的结论是不管是同一个单子还是同一段内容同长度字体的情况下 白体占用的面积比无衬线报体占用面积大，就等于同面积同内容情况下无衬线报体能写的文字数比 白体多，说明无衬线报体同样的面积里信息含量大。</p>
    <br>
    <p>两种字体在18号字体做点阵字体嵌入时的比较（左白体、右无衬线报体）：</p>
    <br>
    <div class="Vsbt-img-cont">
        <div class="Vsbt-img">
            <img src="/assets/images/VsBaiti/17.gif" alt="斡仑字体 - 图片">
            <div>18号字体大小</div>
        </div>
    </div>

</div>